














import Vue from 'vue';
import RidesTable from '@/components/DailyRides/RidesTable.vue';
import RidesMap from '@/components/DailyRides/RidesMap.vue';

export default Vue.extend({
    components: {
        RidesTable,
        RidesMap,
    },
    data() {
        return {
            loading: false,
            date: new Date().toISOString().substr(0, 10),
            myInterval: null as any,
            ongoingRidesData: [] as Array<any>,
            ridesTableData: [] as Array<object>,
            routesPathsData: [] as Array<object>,
            routesStopsData: [] as Array<object>,
        };
    },
    created() {
        this.dateChanged();
    },

    destroyed() {
        this.clearInterval();
    },
    watch: {
        date() {
            this.dateChanged();
        },
    },
    methods: {
        isToday() {
            return this.date === new Date().toISOString().substr(0, 10);
        },

        async dateChanged() {
            // not today - get data only once
            if (!this.isToday()) {
                clearInterval(this.myInterval);
                this.getRidesData(false);

            // case today - update data all the time
            } else {
                this.initInterval();
            }
        },

        async getTableData(isUpdate: boolean) {
            try {
                if (!isUpdate) { this.loading = true; }
                this.ridesTableData = await this.$hipApi.getRidesAtDate(this.date);

            } catch (error) {
                this.$notifier.showError('Failed bringing map data');
                console.error(error?.error?.message || error?.message || error);
            } finally {
                if (!isUpdate) { this.loading = false; }
            }
        },

        async getOngoingRidesData(ridesData: any) {
            let ongoingRidesData = await this.$hipApi.getOngoingRides();
            for (const ongoingRide of ongoingRidesData) {
                ongoingRide.rideDetails = ridesData.find((tableRide: any) => ongoingRide.rideId === tableRide.rideId);
            }
            ongoingRidesData = ongoingRidesData.filter((ride: any) => ride.hasOwnProperty('vehicleLocationData'));
            return ongoingRidesData;
        },

        async getGeoJsonsOfRouteData(ridesData: any) {
            const routesPathsData = await Promise.all(ridesData
                .filter((ride: any) => ride.isOngoing)
                .map(async (ride: any) => ({
                    path: await this.$hipApi.getRideGeojson(ride.rideId),
                    routeName: ride.routeName,
                    rideId: ride.rideId,
                }))) as object[];
            return routesPathsData;
        },

        async getMapData(ridesData: any) {
            try {
                if (this.isToday()) {
                    const [ongoingRidesData, routesPathsData] = await Promise.all([
                        await this.getOngoingRidesData(ridesData),
                        await this.getGeoJsonsOfRouteData(ridesData),
                    ]);

                    // check date didnt move to another date while loading and then set the data after all requests returned
                    if (this.isToday()) {
                        this.routesPathsData = routesPathsData;
                        this.ongoingRidesData = ongoingRidesData;
                        this.routesStopsData = this.ridesTableData.map((ride: any) => ride.extraDetails.rideStops);

                    } else {
                        this.resetMapData();
                    }

                } else {
                    this.resetMapData();
                }

            } catch (error) {
                this.$notifier.showError('Failed bringing map data');
                console.error(error?.error?.message || error?.message || error);
                this.resetMapData();
            }
        },

        async getRidesData(isUpdate: boolean) {
            // main rides data
            await this.getTableData(isUpdate);

            // map locations
            this.getMapData(this.ridesTableData);
        },

        resetMapData() {
            this.ongoingRidesData = [];
            this.routesPathsData = [];
            this.routesStopsData = [];
        },

        async initInterval() {
            await this.getRidesData(false);
            if (this.ridesTableData.length !== 0) {
                this.myInterval = setInterval(() => {
                    this.getRidesData(true);
                }, 15000);
            }
        },

        async clearInterval() {
            if (this.myInterval) {
                clearInterval(this.myInterval);
            }
        },
    },
});
